import germanMessages from "ra-language-german";
import polyglotI18nProvider from "ra-i18n-polyglot";

const messages = {
    de: germanMessages,
};

export const i18nProvider = polyglotI18nProvider(
    (locale) => messages[locale],
    "de", // Default-Sprache
    { allowMissing: true }
);
